import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles.css';
import './hub.css';
import './views.css';
import './org.css';
import './completed.css';
import './collections.css';

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register the service worker in production builds only (not the dev server
// or the emulator, where it just gets in the way of hot reload).
if ('serviceWorker' in navigator && import.meta.env.PROD && import.meta.env.VITE_USE_EMULATORS !== '1') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* SW registration is best-effort; the app works without it */
    });
  });
}
